import styled from "styled-components";
import { typography } from "../../../../../../styles/theme";
import type { DispensationStatus } from "../../types";

export const StatusBadgeWrapper = styled.div<{
  status: DispensationStatus;
}>`
  height: 22px;
  max-height: 22px;
  min-height: 22px;
  border-width: 1px;
  border-style: solid;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;

  border-color: ${({ status }) => {
    if (status === "Não dispensado") return "#4A5568";
    if (status === "Dispensado parcialmente") return "#f59e0b";
    if (status === "Totalmente dispensado") return "#276749";
    return "#d1d5db";
  }};
  background-color: ${({ status }) => {
    if (status === "Não dispensado") return "#EDF2F7";
    if (status === "Dispensado parcialmente") return "#f59e0b15";
    if (status === "Totalmente dispensado") return "#C7F6D5";
    return "#f3f4f6";
  }};
`;

export const StatusBadge = styled.span<{
  status: DispensationStatus;
}>`
  white-space: nowrap;
  font-size: ${typography("caption2.fontSize")};
  color: ${({ status }) => {
    if (status === "Não dispensado") return "#4A5568";
    if (status === "Dispensado parcialmente") return "#92400E";
    if (status === "Totalmente dispensado") return "#276749";
    return "#d1d5db";
  }};
  
  font-weight: ${typography("weights.bold")};
`;